import { AbstractControl, ValidationErrors, ValidatorFn, FormGroup } from "@angular/forms";
import ProductUtils from "../utils/product.utils";

export class CustomFormValidator{
  /**
   * Group-level validator: checks that two password fields match.
   * Sets `passwordsMismatch: true` on the group when they differ.
   */
  static passwordsMatch(passwordCtrl: string, confirmCtrl: string): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const password = group.get(passwordCtrl)?.value;
      const confirm = group.get(confirmCtrl)?.value;
      if (!password || !confirm) return null;
      return password === confirm ? null : { passwordsMismatch: true };
    };
  }

  static validatePassword(comparePwd: string): ValidatorFn{
    return (control: AbstractControl): ValidationErrors | null =>{
      const value = control.value
      if(!value){
        return null
      }
      const hasUpperCase = /[A-Z]+/.test(value)
      const hasLowerCase = /[a-z]+/.test(value)
      const hasNumeric = /[0-9]+/.test(value)
      // const matchPwd =  (value == comparePwd)
      const passwordValid = hasUpperCase && hasLowerCase && hasNumeric
      return !passwordValid ? {passwordStrength:true}: null
    }
  }

  static validDate_StartNextMonth(): ValidatorFn{
    return(control:AbstractControl): ValidationErrors | null => {
      const value = control.value
      if(!value){
        return null
      }
      let nextMonth = null
      const today = new Date()
      if(today.getMonth() < 11){
        nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1)
      }else{
        nextMonth = new Date(today.getFullYear() + 1, today.getMonth() + 1, 1)
      }
      let inputDate = new Date(control.value)
      let inputValid =  inputDate.getTime() > nextMonth.getTime()

      return inputValid ? null:  { startDateValid: true }
    }
  }

  static validImgStartDate(): ValidatorFn{
    return(control:AbstractControl): ValidationErrors | null => {
      const value = control.value
      if(!value){
        return null
      }

      let today = new Date()
      let inputDate = new Date(value)
      let inputValid = inputDate.getTime() > today.getTime()
      return inputValid ? {startDateValid: true} : null
    }
  }

  static validImgEndDate( startDate: Date ): ValidatorFn{
    return(control:AbstractControl): ValidationErrors | null => {
      const value = control.value
      if(!value){
        return null
      }

      let today = new Date()
      let inputDate = new Date(value)

      let diffDays = ProductUtils.getDaysBetweenDates(startDate, inputDate)

      let inputValid = inputDate.getTime() > today.getTime() &&  diffDays >= 10
      return inputValid ? {endDateValid: true} : null
    }
  }
}
